module.exports = __webpack_public_path__ + "img/START.5aa6dfa6.png";